var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contact_support-24px",
    width: 22.763,
    height: 22.763,
    viewBox: "0 0 22.763 22.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    fill: "none",
    d: "M0 0h22.763v22.763H0z",
    "data-name": "Path 297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    d: "M10.536 22.426v-3.414a9.012 9.012 0 1 1 9.485-9c0 4.695-3.263 9.418-8.128 11.761zM11.011 2.9a7.114 7.114 0 0 0 0 14.227h1.423v2.181c3.452-2.181 5.691-5.767 5.691-9.3A7.116 7.116 0 0 0 11.011 2.9zm-.949 10.9h1.9v1.9h-1.9zm1.9-1.423h-1.9c0-3.083 2.845-2.845 2.845-4.742a1.9 1.9 0 1 0-3.794 0h-1.9a3.794 3.794 0 0 1 7.588 0c-.001 2.376-2.842 2.613-2.842 4.747z",
    "data-name": "Path 298",
    transform: "translate(-.103 -.052)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.e057d3b5.svg";
export { ForwardRef as ReactComponent };